import {PostsCalendarEntry} from './posts-calendar-entry';
import {PostInsideDayCardType} from './posts-calendar-type';
import * as styles from './posts-calendar.scss';

type PropsType = {
    entries: Array<PostInsideDayCardType>;
};

// Every publication of the day is listed: the cell grows with its content instead of scrolling, so
// the day's schedule is readable at a glance.
export function PostsCalendarDayCard({entries}: PropsType): JSX.Element {
    return (
        <ul className={styles.PostCalendar_list}>
            {entries.map((entry) => (
                <PostsCalendarEntry entry={entry} key={`${entry.type}-${entry.id}`} />
            ))}
        </ul>
    );
}
